'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * RF Server API
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * this is the API for the RF server
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The version of the OpenAPI document: 1.0.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Contact: bryan@dau.it
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ApiClient = require('../ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _DataTable = require('../model/DataTable');

var _DataTable2 = _interopRequireDefault(_DataTable);

var _ErrorResponse = require('../model/ErrorResponse');

var _ErrorResponse2 = _interopRequireDefault(_ErrorResponse);

var _Movement = require('../model/Movement');

var _Movement2 = _interopRequireDefault(_Movement);

var _MovementList = require('../model/MovementList');

var _MovementList2 = _interopRequireDefault(_MovementList);

var _NewRenderResponse = require('../model/NewRenderResponse');

var _NewRenderResponse2 = _interopRequireDefault(_NewRenderResponse);

var _RenderInfo = require('../model/RenderInfo');

var _RenderInfo2 = _interopRequireDefault(_RenderInfo);

var _ShareRequest = require('../model/ShareRequest');

var _ShareRequest2 = _interopRequireDefault(_ShareRequest);

var _StartRenderResponse = require('../model/StartRenderResponse');

var _StartRenderResponse2 = _interopRequireDefault(_StartRenderResponse);

var _UploadJSON = require('../model/UploadJSON');

var _UploadJSON2 = _interopRequireDefault(_UploadJSON);

var _UploadResponse = require('../model/UploadResponse');

var _UploadResponse2 = _interopRequireDefault(_UploadResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* Movement service.
* @module /api/MovementApi
* @version 1.0.0
*/
var MovementApi = function () {

  /**
  * Constructs a new MovementApi. 
  * @alias module:/api/MovementApi
  * @class
  * @param {module:/ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:/ApiClient#instance} if unspecified.
  */
  function MovementApi(apiClient) {
    _classCallCheck(this, MovementApi);

    this.apiClient = apiClient || _ApiClient2.default.instance;
  }

  /**
   * Callback function to receive the result of the movementGet operation.
   * @callback module:/api/MovementApi~movementGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/DataTable} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * get the movement table
   * **This method must be executed with datatables' flow, in particular it is built over the vue-tables-2 package documentation** 
   * @param {String} authorization use to pass the access token obtained from a login
   * @param {Object} opts Optional parameters
   * @param {String} opts.query 
   * @param {Number} opts.limit 
   * @param {Number} opts.page 
   * @param {String} opts.orderBy 
   * @param {String} opts.ascending 
   * @param {String} opts.byColumn 
   * @param {String} opts.project 
   * @param {module:/api/MovementApi~movementGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/DataTable}
   */


  _createClass(MovementApi, [{
    key: 'movementGet',
    value: function movementGet(authorization, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGet");
      }

      var pathParams = {};
      var queryParams = {
        'query': opts['query'],
        'limit': opts['limit'],
        'page': opts['page'],
        'orderBy': opts['orderBy'],
        'ascending': opts['ascending'],
        'byColumn': opts['byColumn'],
        'project': opts['project']
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DataTable2.default;
      return this.apiClient.callApi('/movement', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidDelete operation.
     * @callback module:/api/MovementApi~movementGuidDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete a movement
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {module:/api/MovementApi~movementGuidDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'movementGuidDelete',
    value: function movementGuidDelete(authorization, guid, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidDelete");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidDelete");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/movement/{guid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidImageNamedownloadImageGet operation.
     * @callback module:/api/MovementApi~movementGuidImageNamedownloadImageGetCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get a a render's image
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {String} image use to pass the image of the render
     * @param {module:/api/MovementApi~movementGuidImageNamedownloadImageGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */

  }, {
    key: 'movementGuidImageNamedownloadImageGet',
    value: function movementGuidImageNamedownloadImageGet(authorization, guid, image, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidImageNamedownloadImageGet");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidImageNamedownloadImageGet");
      }
      // verify the required parameter 'image' is set
      if (image === undefined || image === null) {
        throw new Error("Missing the required parameter 'image' when calling movementGuidImageNamedownloadImageGet");
      }

      var pathParams = {
        'guid': guid,
        'image': image
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['image/jpeg'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/movement/{guid}/{image}/name:downloadImage', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidNameInfoGet operation.
     * @callback module:/api/MovementApi~movementGuidNameInfoGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Movement} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * movevement's info
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid of the movement
     * @param {module:/api/MovementApi~movementGuidNameInfoGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Movement}
     */

  }, {
    key: 'movementGuidNameInfoGet',
    value: function movementGuidNameInfoGet(authorization, guid, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidNameInfoGet");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidNameInfoGet");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Movement2.default;
      return this.apiClient.callApi('/movement/{guid}/name:Info', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidNameSharePost operation.
     * @callback module:/api/MovementApi~movementGuidNameSharePostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * share a movement with users
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {module:model/ShareRequest} body List of user with you are sharing the movement
     * @param {module:/api/MovementApi~movementGuidNameSharePostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'movementGuidNameSharePost',
    value: function movementGuidNameSharePost(authorization, guid, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidNameSharePost");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidNameSharePost");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling movementGuidNameSharePost");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/movement/{guid}/name:Share', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidNamepreviewImageGet operation.
     * @callback module:/api/MovementApi~movementGuidNamepreviewImageGetCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get a preview image of the render
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {module:/api/MovementApi~movementGuidNamepreviewImageGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */

  }, {
    key: 'movementGuidNamepreviewImageGet',
    value: function movementGuidNamepreviewImageGet(authorization, guid, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidNamepreviewImageGet");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidNamepreviewImageGet");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/movement/{guid}/name:previewImage', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidNamestartMovementRenderPost operation.
     * @callback module:/api/MovementApi~movementGuidNamestartMovementRenderPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StartRenderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * upload finished and start render
     * Use thi methods to comunicate to the server that the upload is finished, and start the rendering process 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {module:/api/MovementApi~movementGuidNamestartMovementRenderPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StartRenderResponse}
     */

  }, {
    key: 'movementGuidNamestartMovementRenderPost',
    value: function movementGuidNamestartMovementRenderPost(authorization, guid, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidNamestartMovementRenderPost");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidNamestartMovementRenderPost");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _StartRenderResponse2.default;
      return this.apiClient.callApi('/movement/{guid}/name:startMovementRender', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidUploadFilePost operation.
     * @callback module:/api/MovementApi~movementGuidUploadFilePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UploadResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * upload a file for a guid
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {Object} file 
     * @param {module:/api/MovementApi~movementGuidUploadFilePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UploadResponse}
     */

  }, {
    key: 'movementGuidUploadFilePost',
    value: function movementGuidUploadFilePost(authorization, guid, file, callback) {
      var postBody = file;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidUploadFilePost");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidUploadFilePost");
      }
      // verify the required parameter 'file' is set
      if (file === undefined || file === null) {
        throw new Error("Missing the required parameter 'file' when calling movementGuidUploadFilePost");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UploadResponse2.default;
      return this.apiClient.callApi('/movement/{guid}/uploadFile', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementGuidUploadJSONPost operation.
     * @callback module:/api/MovementApi~movementGuidUploadJSONPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * upload a JSON string for a guid
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} guid use to pass the guid generated from the service
     * @param {module:model/UploadJSON} json The json file to be uploaded
     * @param {module:/api/MovementApi~movementGuidUploadJSONPostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'movementGuidUploadJSONPost',
    value: function movementGuidUploadJSONPost(authorization, guid, json, callback) {
      var postBody = json;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementGuidUploadJSONPost");
      }
      // verify the required parameter 'guid' is set
      if (guid === undefined || guid === null) {
        throw new Error("Missing the required parameter 'guid' when calling movementGuidUploadJSONPost");
      }
      // verify the required parameter 'json' is set
      if (json === undefined || json === null) {
        throw new Error("Missing the required parameter 'json' when calling movementGuidUploadJSONPost");
      }

      var pathParams = {
        'guid': guid
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/movement/{guid}/uploadJSON', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementNameCreateMovementPost operation.
     * @callback module:/api/MovementApi~movementNameCreateMovementPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewRenderResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new render, retrieve the GUID
     * Verificare se servono tutti e due i token oppure se una volta ottenuto il guid è sufficiente 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} authorizationSoftware use to pass the token obtained from the software
     * @param {module:model/RenderInfo} body User object to add in the DB, instead of the old one.
     * @param {module:/api/MovementApi~movementNameCreateMovementPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewRenderResponse}
     */

  }, {
    key: 'movementNameCreateMovementPost',
    value: function movementNameCreateMovementPost(authorization, authorizationSoftware, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementNameCreateMovementPost");
      }
      // verify the required parameter 'authorizationSoftware' is set
      if (authorizationSoftware === undefined || authorizationSoftware === null) {
        throw new Error("Missing the required parameter 'authorizationSoftware' when calling movementNameCreateMovementPost");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling movementNameCreateMovementPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization,
        'AuthorizationSoftware': authorizationSoftware
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _NewRenderResponse2.default;
      return this.apiClient.callApi('/movement/name:CreateMovement', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementNameMovementListGet operation.
     * @callback module:/api/MovementApi~movementNameMovementListGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MovementList} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * list of movement
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {module:/api/MovementApi~movementNameMovementListGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MovementList}
     */

  }, {
    key: 'movementNameMovementListGet',
    value: function movementNameMovementListGet(authorization, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementNameMovementListGet");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _MovementList2.default;
      return this.apiClient.callApi('/movement/name:MovementList', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the movementProjectListGet operation.
     * @callback module:/api/MovementApi~movementProjectListGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DataTable} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get the list of the project(ecadpro orders) involved
     * **This method must be executed with datatables' flow, in particular it is built over the vue-tables-2 package documentation** 
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {Object} opts Optional parameters
     * @param {String} opts.query 
     * @param {Number} opts.limit 
     * @param {Number} opts.page 
     * @param {String} opts.orderBy not used for this query
     * @param {String} opts.ascending 
     * @param {module:/api/MovementApi~movementProjectListGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DataTable}
     */

  }, {
    key: 'movementProjectListGet',
    value: function movementProjectListGet(authorization, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling movementProjectListGet");
      }

      var pathParams = {};
      var queryParams = {
        'query': opts['query'],
        'limit': opts['limit'],
        'page': opts['page'],
        'orderBy': opts['orderBy'],
        'ascending': opts['ascending']
      };
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DataTable2.default;
      return this.apiClient.callApi('/movement/projectList', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return MovementApi;
}();

exports.default = MovementApi;
//# sourceMappingURL=MovementApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/renderfarmapi/lib/lib-commonjs/api/MovementApi.js
// module id = 1450
// module chunks = 142